import { useContext, useEffect, useState } from "react";

import UserAccount from "./UserAccount";
import axios from "axios";
import { MyContext } from "../../../context/MyContext";
export default function BankDetails({ bankdata, existBank, handleForm }) {
  const { getBankDetails } = useContext(MyContext);
  console.log(bankdata);
  const [bankDetails, setBankDetails] = useState({
    account_holder_name: bankdata != null ? bankdata?.account_holder_name : "",
    account_number: bankdata != null ? bankdata?.account_number : "",
    confirm_account_number:
      bankdata != null ? bankdata?.confirm_account_number : "",
    bank_name: bankdata != null ? bankdata?.bank_name : "",
    ifsc_code: bankdata != null ? bankdata?.ifsc_code : "",
  });

  console.log(
    bankdata,
    "+++++++++++++++++++++++++++++++++++++++++++++++++++> Sunny Rajbhar",
    bankdata
  );
  const [error, setError] = useState("");
  const [formError, setFormError] = useState(""); // Track form errors
  const [showSuccess, setShowSuccess] = useState(false);
  const [isNomineeEnabled, setIsNomineeEnabled] = useState(false);
  const [isBankDetailsDisabled, setIsBankDetailsDisabled] = useState(false);
  const [isStepDisabled, setIsStepDisabled] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    console.log(e);
    setBankDetails({ ...bankDetails, [e.target.name]: e.target.value });

    if (e.target.name === "confirm_account_number") {
      setError(
        e.target.value !== bankDetails.account_number
          ? "Please enter correct account number"
          : ""
      );
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!bankDetails.account_holder_name.trim()) {
      newErrors.account_holder_name = "Nmae is required";
    }
    if (!bankDetails.account_number.trim()) {
      newErrors.account_number = "Account Number is required";
    }
    if (!bankDetails.bank_name.trim()) {
      newErrors.bank_name = "Bank Name is required";
    }
    if (!bankDetails.ifsc_code.trim()) {
      newErrors.ifsc_code = "IFSC code is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const handleUpdate = async () => {
  //   const formData = new FormData();
  //   formData.append("addharFront", adharFront);
  //   formData.append("addharBack", adharBack);
  //   formData.append("pan", panImage);
  //   formData.append("account_holder_name", bankDetails.account_holder_name);
  //   formData.append("account_number", bankDetails.account_number);
  //   formData.append(
  //     "confirm_account_number",
  //     bankDetails.confirm_account_number
  //   );
  //   formData.append("bank_name", bankDetails.bank_name);
  //   formData.append("ifsc_code", bankDetails.ifsc_code);
  //   formData.append("nominee_name", bankDetails.nominee_name);
  //   formData.append("nominee_address", bankDetails.nominee_address);
  //   formData.append(
  //     "nominee_dob",
  //     selectedDay + "/" + selectedMonth + "/" + selectedYear
  //   );
  //   formData.append("panNumber", panNumber);
  //   formData.append("addharNumber", adharNumber);
  //   try {
  //     const userId = localStorage.getItem("userId");
  //     const updateResponse = await axios.post(
  //       `${process.env.REACT_APP_NODE}/user/banks/${userId}`,
  //       formData
  //     );
  //     console.log("bank details", updateResponse);
  //     handleForm();
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const handleSubmit = async (e) => {
    if (!validate()) return;

    try {
      const userId = localStorage.getItem("userId");

      const newObject = {
        account_holder_name: bankDetails.account_holder_name,
        account_number: bankDetails.account_number,
        confirm_account_number: bankDetails.confirm_account_number,
        bank_name: bankDetails.bank_name,
        ifsc_code: bankDetails.ifsc_code,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_NODE}/user/banks/${userId}`,
        newObject
      );

      //   console.log("bank details", response);
      getBankDetails();
      handleForm();
    } catch (err) {
      console.log(err);
    }

    e.preventDefault();
    setFormError("");

    console.log("Bank Details Submitted:", bankDetails);

    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);

    console.log("Nominee DOB :", bankDetails.nominee_dob);
    setBankDetails({
      account_holder_name: "",
      account_number: "",
      confirm_account_number: "",
      bank_name: "",
      ifsc_code: "",
      nominee_name: "",
      nominee_address: "",
      nominee_dob: "",
    });

    // Reset step control to enable Step 1 again
    setIsNomineeEnabled(false);
    setIsBankDetailsDisabled(false);
    setIsStepDisabled(false);
  };

  return (
    <div className="max-w-7xl mx-auto mt-1 px-6 py-5 rounded-2xl shadow-md bg-white  overflow-y-auto   ">
      <div className="flex flex-wrap gap-6 justify-center">
        <div
          className={`flex-1 ${
            isBankDetailsDisabled ? "pointer-events-none opacity-50" : ""
          }`}
        >
          <form>
            <div
              className={`mb-4 ${
                isStepDisabled ? "opacity-50 pointer-events-none" : ""
              }`}
            >
              <h2 className="text-xl font-bold mb-4 text-[#a855f7]">
                Bank Details
              </h2>
            </div>

            <div className="mb-4">
              <label className="block font-semibold text-gray-600">
                Account Holder Name
              </label>
              <input
                type="text"
                name="account_holder_name"
                value={bankDetails.account_holder_name}
                onChange={handleChange}
                className="w-full p-2 border rounded-xl focus:ring-2 focus:ring-purple-500"
                required
              />
              {errors.account_holder_name && (
                <p className="text-red-500 text-sm">
                  {errors.account_holder_name}
                </p>
              )}
            </div>

            <div className="mb-4">
              <label className="block font-semibold text-gray-600">
                Account Number
              </label>
              <input
                type="text"
                name="account_number"
                value={bankDetails.account_number}
                onChange={handleChange}
                className="w-full p-2 border rounded-xl focus:ring-2 focus:ring-purple-500"
                required
              />
              {errors.account_number && (
                <p className="text-red-500 text-sm">{errors.account_number}</p>
              )}
            </div>

            <div className="mb-4">
              <label className="block font-semibold text-gray-600">
                Confirm Account Number
              </label>
              <input
                type="text"
                name="confirm_account_number"
                value={bankDetails.confirm_account_number}
                onChange={handleChange}
                className="w-full p-2 border rounded-xl focus:ring-2 focus:ring-purple-500"
                required
              />
              {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
            </div>

            <div className="mb-4">
              <label className="block font-semibold text-gray-600">
                Bank Name
              </label>
              <input
                type="text"
                name="bank_name"
                value={bankDetails.bank_name}
                onChange={handleChange}
                className="w-full p-2 border rounded-xl focus:ring-2 focus:ring-purple-500"
                required
              />
              {errors.bank_name && (
                <p className="text-red-500 text-sm">{errors.bank_name}</p>
              )}
            </div>

            <div className="mb-4">
              <label className="block font-semibold text-gray-600">
                IFSC Code
              </label>
              <input
                type="text"
                name="ifsc_code"
                value={bankDetails.ifsc_code}
                onChange={handleChange}
                className="w-full p-2 border rounded-xl focus:ring-2 focus:ring-purple-500"
                required
              />
              {errors.ifsc_code && (
                <p className="text-red-500 text-sm">{errors.ifsc_code}</p>
              )}
            </div>

            <div className="mb-4 w-full">
              {!existBank && (
                <button
                  onClick={handleSubmit}
                  className="p-2 w-full text-white rounded-xl shadow-md hover:shadow-lg transition bg-[#a855f7] float-right"
                >
                  Add Details
                </button>
              )}
              {formError && (
                <p className="text-red-500 text-sm mt-1">{formError}</p>
              )}
            </div>
          </form>
        </div>

        {showSuccess && (
          <div className="fixed  right-0 bg-green-500 text-white px-4 py-2 rounded-lg shadow-lg ">
            Details added successfully!
          </div>
        )}
      </div>
    </div>
  );
}
